import { render } from "./Preview.vue?vue&type=template&id=5950d468&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=ts"
export * from "./Preview.vue?vue&type=script&lang=ts"

import "./Preview.vue?vue&type=style&index=0&id=5950d468&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5950d468"

export default script